import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroEntradasSaidas } from '@/features/relatorio/page/financeiro/entradas-saidas/RelatorioFinanceiroEntradasSaidas';

export const Route = createFileRoute('/a/relatorio/financeiro/entradas-saidas')({
    component: RelatorioFinanceiroEntradasSaidas,
});
